import React from 'react';
import { PaxStatementHeader } from './PaxStatementHeader';
import { PaxStatementBookingSummary } from './PaxStatementBookingSummary';
import { PaxStatementAgentCustomer } from './PaxStatementAgentCustomer';
import { PaxStatementTravellers } from './PaxStatementTravellers';
import { PaxStatementProducts } from './PaxStatementProducts';
import { PaxStatementPayments } from './PaxStatementPayments';
import { PaxStatementNotes } from './PaxStatementNotes';
import { PaxStatementFooter } from './PaxStatementFooter';
export function PaxStatement() {
  const companyInfo = {
    name: 'MyTourix Travel Management',
    address: ['123 Orchard Road, #12-34', 'Singapore 238858'],
    phone: '+65 6789 1234',
    uen: '201234567G'
  };
  const statementInfo = {
    number: 'PAX-2025-00234',
    printedOn: '23 Jan 2025, 2:30 PM',
    printedBy: 'System Admin',
    bookingReference: 'CTB25110009',
    salesOwner: 'Oliver Davis',
    bookingStatus: 'Confirmed' as const
  };
  const bookingInfo = {
    bookingRef: 'CTB25110009',
    productName: 'Japan Discovery 8D7N',
    tourCode: 'JP-2025-APR',
    departure: '15 Apr 2025',
    return: '22 Apr 2025',
    bookingDate: '01 Feb 2025',
    bookingStaff: 'Oliver Davis',
    bookingStaffEmail: 'oliver.davis@mytourix.com',
    paymentReceived: 4000.0,
    totalAmount: 8524.7,
    balanceDueDate: '15 Mar 2025',
    currency: 'SGD'
  };
  const customerInfo = {
    primaryContact: 'Sarah Johnson',
    email: 'sarah.johnson@email.com',
    phone: '+65 9123 4567',
    address: ['45 Maple Avenue, #12-34', 'Singapore 123456'],
    bookingStatus: 'Confirmed'
  };
  const rooms = [{
    roomNumber: 'Room 101',
    roomType: 'Twin Share',
    travellers: [{
      name: 'Sarah Johnson',
      dateOfBirth: '15 Mar 1985',
      passportNo: 'E1234567',
      expiry: '20 Dec 2028',
      nationality: 'Singapore',
      mealNotes: 'Vegetarian',
      visa: 'Not Required'
    }, {
      name: 'Michael Johnson',
      dateOfBirth: '22 Jul 1983',
      passportNo: 'E7654321',
      expiry: '15 Jan 2029',
      nationality: 'Singapore',
      visa: 'Not Required'
    }]
  }, {
    roomNumber: 'Room 102',
    roomType: 'Single',
    travellers: [{
      name: 'Emily Chen',
      dateOfBirth: '08 Nov 1990',
      passportNo: 'E9876543',
      expiry: '30 Jun 2027',
      nationality: 'Singapore',
      mealNotes: 'No seafood',
      visa: 'Not Required'
    }]
  }];
  const products = [{
    item: 'Tour Package – Adult',
    unit: 2,
    unitPrice: 2899.0,
    discount: 0,
    amount: 5798.0
  }, {
    item: 'Tour Package – Child',
    unit: 1,
    unitPrice: 1999.0,
    amount: 1999.0
  }, {
    item: 'Airport Transfer',
    description: 'Private van return',
    unit: 1,
    unitPrice: 180.0,
    amount: 180.0
  }, {
    item: 'L2 Disc (per pax)',
    unit: 4,
    unitPrice: 1500.0,
    discount: 1500.0,
    amount: -6000.0
  }, {
    item: 'Agent Commission',
    unit: 1,
    unitPrice: 789.12,
    discount: 789.12,
    amount: -789.12
  }];
  const productTotals = {
    subtotal: 8187.82,
    totalDiscount: 6789.12,
    totalGST: 336.88,
    grandTotal: 8524.7,
    currency: 'SGD'
  };
  const payments = [{
    transaction: 'Deposit',
    docNo: 'RCPT-2025-00123',
    date: '01 Feb 2025',
    paymentMethod: 'Credit Card',
    amount: 3000.0,
    balance: 5524.7
  }, {
    transaction: 'Instalment',
    docNo: 'RCPT-2025-00178',
    date: '15 Feb 2025',
    paymentMethod: 'Bank Transfer',
    amount: 1000.0,
    balance: 4524.7
  }];
  const externalNotes = `Passenger dietary requirements: Vegetarian meal for Sarah Johnson on all days. No seafood for Emily Chen.

Please ensure all passports have minimum 6 months validity from date of return (22 Apr 2025).

Airport transfer will be arranged for 15 Apr 2025 at 6:00 AM. Please be ready at hotel lobby 10 minutes before pickup time.

Tour guide contact: Mr. Tanaka Yamamoto, Mobile: +81 90 1234 5678`;
  const termsAndConditions = `• Tour manager may adjust itinerary based on weather conditions.
• Travellers must ensure passport validity of 6 months from date of return.
• Final confirmation subject to supplier availability.
• Cancellation fees apply as per booking terms.
• Travel insurance is strongly recommended for all travellers.`;
  const footerInfo = {
    name: 'MyTourix Travel Management',
    address: '123 Orchard Road, #12-34, Singapore 238858',
    phone: '+65 6789 1234',
    email: 'info@mytourix.com'
  };
  const qrCodeUrl = 'https://api.qrserver.com/v1/create-qr-code/?size=140x140&data=CTB25110009';
  return <div className="h-full overflow-auto bg-gradient-to-br from-neutral-50 to-neutral-100 p-8" data-id="element-611">
      <div className="max-w-6xl mx-auto bg-white shadow-lg rounded-xl p-10" data-id="element-612">
        <PaxStatementHeader company={companyInfo} statement={statementInfo} data-id="element-613" />
        <PaxStatementBookingSummary booking={bookingInfo} data-id="element-614" />
        <PaxStatementAgentCustomer customer={customerInfo} qrCodeUrl={qrCodeUrl} data-id="element-615" />
        <PaxStatementTravellers rooms={rooms} data-id="element-616" />
        <PaxStatementProducts items={products} totals={productTotals} data-id="element-617" />
        <PaxStatementPayments transactions={payments} currency="SGD" data-id="element-618" />
        <PaxStatementNotes externalNotes={externalNotes} termsAndConditions={termsAndConditions} termsUrl="https://www.mytourix.com/terms" showDeclaration={true} bookingStaffName="Oliver Davis" data-id="element-619" />
        <PaxStatementFooter company={footerInfo} data-id="element-620" />
      </div>
    </div>;
}